<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="900px"
      :style="{ zIndex: options.zIndex }"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <h2 v-if="!editMode">Neuen Ordner erstellen</h2>
          <h2 v-else>Ordner bearbeiten</h2>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-7">
          <p
            v-if="error != null"
            style="color: var(--v-error-base)"
            v-html="error"
          />
          <v-container>
            <v-row style="width: 100%, height: 50%;">
              <v-text-field
                v-model="folderName"
                label="Ordnername (max. 100 Zeichen)"
                required
                maxlength="100"
              ></v-text-field>
            </v-row>
            <v-row style="width: 100%, height: 50%;">
              <h3>Berechtigungen für Prozesse in diesem Ordner</h3>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Bezeichnung</th>
                      <th
                        style="width: 25px"
                        v-for="permission in permissions"
                        :key="permission"
                      >
                        <v-tooltip max-width="250px" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-on="on" v-bind="attrs">
                              {{ decodePermissionName(permission) }}
                            </div>
                          </template>
                          <span>
                            {{ getPermissionDescription(permission) }}
                          </span>
                        </v-tooltip>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="role in roles" :key="role.id">
                      <td>{{ role.roleTitle }}</td>
                      <td
                        style="width: 25px"
                        v-for="permission in permissions"
                        :key="permission"
                      >
                        <v-checkbox
                          :disabled="
                            permission == 'PROCESS_READ' &&
                            role.permissions['PROCESS_WRITE']
                          "
                          @click="permissionsChanged(role, permission)"
                          v-model="role.permissions[permission]"
                          color="secondary"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <!-- <v-col>
            <v-card id="cardFrame" fluid class="fill-height  text-center" elevation="0" @click="sendResponse('IMPORT')">
              <v-card elevation="0" class="py-6 d-flex justify-center">
                <div class="svg-container mt-4">
                  <svg viewBox="0 0 72 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1493_9216)">
                      <ellipse cx="42.3411" cy="25.8599" rx="29.3411" ry="25.8599" fill="#F1F1F1"/>
                      <path d="M67.4352 10.4136V5.57979H42.0427L37.2089 0.745972H11.8164L6.98261 5.57979H0.945312V46.6871M0.945312 46.6871H4.5657M0.945312 46.6871L9.39952 10.4136H71.0655L62.6013 46.6871H21.494M22.4687 37.2483C21.5238 36.3034 19.9921 36.3034 19.0473 37.2483L8.79281 47.5027C7.84792 48.4476 7.84792 49.9793 8.79281 50.9242C9.73769 51.8691 11.2694 51.8691 12.2143 50.9242L22.4687 40.6697C23.4136 39.7248 23.4136 38.1931 22.4687 37.2483ZM22.4687 37.2483L25.8902 33.8268M38.7108 31.2607C35.8761 34.0953 31.281 34.0953 28.4563 31.2607C25.6216 28.426 25.6216 23.8309 28.4563 21.0062C31.2909 18.1716 35.8861 18.1716 38.7108 21.0062C41.5454 23.8409 41.5454 28.436 38.7108 31.2607ZM44.4596 26.1384C44.4596 32.1479 39.588 37.0195 33.5785 37.0195C27.5691 37.0195 22.6975 32.1479 22.6975 26.1384C22.6975 20.129 27.5691 15.2574 33.5785 15.2574C39.588 15.2574 44.4596 20.129 44.4596 26.1384Z" stroke="#B7B7B7" stroke-width="1.5" stroke-miterlimit="10"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1493_9216">
                        <rect width="72" height="52.3763" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </v-card>
                <v-card-title primary-title class="justify-center p-0">
                  <h3 class="m-0">Importieren</h3>
                </v-card-title>
                <v-card-subtitle class="text-left mt-5 px-7 pb-10">
                  Importiere ein Modell und erfasse basierend darauf die Process Experience.
                </v-card-subtitle>
            </v-card>
        </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            id="singleButton"
            v-if="!editMode"
            color="primary"
            elevation="0"
            @click="submitFolder()"
          >
            <v-icon color="#F5F5F5" medium>add</v-icon> Ordner anlegen
          </v-btn>
          <v-btn
            id="singleButton"
            v-else
            color="primary"
            elevation="0"
            @click="editFolder()"
          >
            <v-icon color="#F5F5F5" medium>edit</v-icon> Ordner bearbeiten
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import permissionService from "@/components/permissionService";
import roleService from "@/pages/UserManagement/roleService";
import folderService from "@/components/folder-service";
import {
  decodePermissionName,
  getPermissionDescription,
} from "@/components/util.js";
export default {
  name: "NewFolderDialog",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        width: 800,
        zIndex: 400,
      },
      folderName: null,
      roles: [],
      permissions: [],
      editMode: false,
      folderData: null,
      error: null,
    };
  },
  computed: {
    userRoles() {
      return this.$store.state.currentUser.roles;
    },
  },
  methods: {
    decodePermissionName: decodePermissionName,
    getPermissionDescription: getPermissionDescription,
    open(editMode, folderData = null) {
      this.editMode = editMode;
      if (editMode && folderData) {
        this.folderData = folderData;
        /*       this.permissions = folderData.permissions; */
        this.folderName = folderData.folderName;

        roleService.retrieveRoles().then((res) => {
          this.roles = res.data;

          permissionService.retrievePossibleProcessPermissions().then((res) => {
            this.permissions = res.data;
            this.roles.forEach((role) => {
              role.permissions = Object.keys(role.permissions).reduce(
                (result, key) => {
                  if (this.permissions.includes(key)) {
                    result[key] = role.permissions[key];
                  }
                  return result;
                },
                {}
              );
              for (let key of this.permissions) {
                let val = folderData.folderPermissions.filter(
                  (elem) => elem.roleId == role.id
                )[0];
                let permissionVal =
                  val && val.folderPermission && val.folderPermission[key]
                    ? val.folderPermission[key]
                    : false;
                this.$set(role.permissions, key, permissionVal);
              }
            });
            this.dialog = true;
          });
        });
      } else {
        roleService.retrieveRoles().then((res) => {
          this.roles = res.data;
          this.roles.forEach((role) => {
            for (const [key, value] of Object.entries(role.permissions)) {
              role.permissions[key] = false;
            }
          });
          permissionService.retrievePossibleProcessPermissions().then((res) => {
            this.permissions = res.data;
            this.dialog = true;
          });
        });
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    sendResponse(res) {
      this.folderName = "";
      this.error = null;
      this.resolve(res);
      this.dialog = false;
    },
    close() {
      this.folderName = "";
      this.error = null;
      this.reject();
      this.dialog = false;
    },
    submitFolder() {
      let permissions = [];
      this.roles.forEach((role) => {
        permissions.push({
          roleId: role.id,
          folderPermission: Object.fromEntries(
            Object.entries(role.permissions).filter(([key]) =>
              this.permissions.includes(key)
            )
          ),
        });
      });
      if (this.folderName == "" || this.folderName == null) {
        this.error = "Sie müssen den Ordnernamen ausfüllen!";
      } else if (
        permissions.filter(
          (elem) =>
            this.userRoles.map((elem) => elem.id).includes(elem.roleId) &&
            elem.folderPermission["PROCESS_READ"] == true
        ).length <= 0
      ) {
        this.error =
          "Sie müssen die Berechtigung 'Prozesse anzeigen' für eine von ihrem Account genutzte Rolle vergeben um den Ordner in Ihrer Liste anzeigen zu können. <br/> Ihre Rollen sind: " +
          this.userRoles
            .map((elem) => elem.roleTitle)
            .join(", ")
            .bold();
      } else {
        let folderData = {
          folderName: this.folderName,
          folderPermissions: permissions,
        };
        folderService.saveFolder(folderData).then((res) => {
          this.sendResponse();
        });
      }
    },
    editFolder() {
      if (this.folderName == "" || this.folderName == null) {
        this.error = "Sie müssen den Ordnernamen ausfüllen!";
        return;
      }
      if (
        this.folderData.folderPermissions.filter(
          (elem) =>
            this.userRoles.map((elem) => elem.id).includes(elem.roleId) &&
            elem.folderPermission["PROCESS_READ"] == true
        ).length <= 0
      ) {
        this.error =
          "Sie müssen die Berechtigung 'Prozesse anzeigen' für eine von ihrem Account genutzte Rolle vergeben um den Ordner in Ihrer Liste anzeigen zu können. <br/> Ihre Rollen sind: " +
          this.userRoles
            .map((elem) => elem.roleTitle)
            .join(", ")
            .bold();
      }
      this.folderData.folderPermissions.forEach((permission) => {
        let role = this.roles.filter((elem) => elem.id == permission.roleId)[0];
        this.roles = this.roles.filter((elem) => elem.id != permission.roleId);
        Object.keys(role.permissions).forEach((elem) => {
            permission.folderPermission[elem] = role.permissions[elem];
        });
      });
      this.roles.forEach((role) => {
        this.folderData.folderPermissions.push({
          roleId: role.id,
          folderPermission: Object.fromEntries(
            Object.entries(role.permissions).filter(([key]) =>
              this.permissions.includes(key)
            )
          ),
        });
      });
      this.folderData.folderName = this.folderName;
      this.folderData.processes = [];
      folderService
        .editFolder(this.folderData.id, this.folderData)
        .then((res) => {
          this.sendResponse();
        });
    },
    permissionsChanged(role, permission) {
      if (role.permissions[permission]) {
        if (permission == "PROCESS_WRITE")
          role.permissions["PROCESS_READ"] = true;
      }
    },
  },
};
</script>
<style scoped>
h3 {
  color: #575757;
}
.v-dialog {
  overflow-y: unset !important;
}
#cardFrame {
  border-radius: 10px;
  border: 1px solid #efefef;
}
.svg-container {
  width: 5rem;
  height: 5rem;
}
</style>
